(() => {
  const initCharacterCounters = (root = document) => {
    root.querySelectorAll('[data-sle-personalization]').forEach((field) => {
      if (field.dataset.sleCounterReady === 'true') return;
      const counter = document.querySelector(`[data-sle-character-count="${field.id}"]`);
      const update = () => {
        if (counter) counter.textContent = `${field.value.length}/${field.maxLength}`;
      };
      field.addEventListener('input', update);
      field.dataset.sleCounterReady = 'true';
      update();
    });
  };

  const initCarousel = (carousel) => {
    if (!carousel || carousel.dataset.sleReady === 'true') return;
    const slides = [...carousel.querySelectorAll('[data-sle-slide]')];
    const dots = [...carousel.querySelectorAll('[data-sle-dot]')];
    const previous = carousel.querySelector('[data-sle-prev]');
    const next = carousel.querySelector('[data-sle-next]');
    const currentCounter = carousel.querySelector('[data-sle-hero-current]');
    if (!slides.length) return;

    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    const delay = Math.max(3000, Number(carousel.dataset.delay) || 5000);
    const pauseOnHover = carousel.dataset.pauseHover === 'true';
    const autoplay = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (index, userInitiated = false) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button, input, textarea, select').forEach((element) => {
          element.tabIndex = active ? 0 : -1;
        });
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      if (currentCounter) currentCounter.textContent = String(current + 1).padStart(2, '0');
      if (userInitiated) restart();
    };

    const stop = () => window.clearInterval(timer);
    const start = () => {
      stop();
      if (autoplay && slides.length > 1) timer = window.setInterval(() => show(current + 1), delay);
    };
    const restart = () => { stop(); start(); };

    previous?.addEventListener('click', () => show(current - 1, true));
    next?.addEventListener('click', () => show(current + 1, true));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.sleDot), true)));
    if (pauseOnHover) {
      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
    }
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', (event) => {
      if (!carousel.contains(event.relatedTarget)) start();
    });
    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(current - 1, true);
      if (event.key === 'ArrowRight') show(current + 1, true);
    });

    carousel.dataset.sleReady = 'true';
    show(current);
    start();
  };

  const initCategorySection = (section) => {
    if (!section || section.dataset.sleRailReady === 'true') return;
    const rail = section.querySelector('[data-sle-scroll-rail]');
    const previous = section.querySelector('[data-sle-rail-prev]');
    const next = section.querySelector('[data-sle-rail-next]');
    if (!rail) return;

    const distance = () => {
      const firstCard = rail.firstElementChild;
      if (!firstCard) return rail.clientWidth * .8;
      const styles = window.getComputedStyle(rail);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 16;
      return firstCard.getBoundingClientRect().width + gap;
    };

    previous?.addEventListener('click', () => rail.scrollBy({ left: -distance(), behavior: 'smooth' }));
    next?.addEventListener('click', () => rail.scrollBy({ left: distance(), behavior: 'smooth' }));
    section.dataset.sleRailReady = 'true';
  };

  const initQuotes = (section) => {
    if (!section || section.dataset.sleQuotesReady === 'true') return;
    const quotes = [...section.querySelectorAll('[data-sle-quote]')];
    const previous = section.querySelector('[data-sle-quote-prev]');
    const next = section.querySelector('[data-sle-quote-next]');
    const counter = section.querySelector('[data-sle-quote-current]');
    if (!quotes.length) return;

    let current = Math.max(0, quotes.findIndex((quote) => quote.classList.contains('is-active')));
    const show = (index) => {
      current = (index + quotes.length) % quotes.length;
      quotes.forEach((quote, quoteIndex) => {
        const active = quoteIndex === current;
        quote.classList.toggle('is-active', active);
        quote.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (counter) counter.textContent = String(current + 1);
    };

    previous?.addEventListener('click', () => show(current - 1));
    next?.addEventListener('click', () => show(current + 1));
    section.dataset.sleQuotesReady = 'true';
    show(current);
  };

  const updateLegacyPersonalizationCopy = (root = document) => {
    root.querySelectorAll('.product__accordion .accordion__content').forEach((container) => {
      let replacementAdded = false;
      container.querySelectorAll('p, div').forEach((node) => {
        const text = (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
        const isLegacyInstruction =
          text.includes('you will add all personalization information when you check out') ||
          (text.includes('order special instructions') && text.includes('personalization'));

        if (!isLegacyInstruction) return;
        if (!replacementAdded) {
          node.textContent = 'Please enter all personalization details in the fields above before adding this item to your cart.';
          node.classList.add('sle-updated-personalization-copy');
          replacementAdded = true;
        } else {
          node.remove();
        }
      });
    });
  };

  const initAll = (root = document) => {
    initCharacterCounters(root);
    root.querySelectorAll('[data-sle-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-sle-category-section]').forEach(initCategorySection);
    root.querySelectorAll('[data-sle-quotes]').forEach(initQuotes);
    updateLegacyPersonalizationCopy(root);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
